import React from 'react';
import PropTypes from 'prop-types';

const EmailInput = props => (
  <textarea
    style={{ height: props.inputAreaHeight }}
    onKeyUp={props.expandTextArea}
    onPaste={props.expandTextArea}
    onCut={props.expandTextArea}
    onKeyPress={event => props.enterPush(props.postUrl, props.useV3, event)}
    placeholder={props.translations.email}
    name="coworkers"
    className={props.error ? 'invalid' : null}
    required
  />
);

EmailInput.propTypes = {
  translations: PropTypes.objectOf(PropTypes.string).isRequired,
  error: PropTypes.string,
  enterPush: PropTypes.func.isRequired,
  postUrl: PropTypes.string.isRequired,
  expandTextArea: PropTypes.func.isRequired,
  inputAreaHeight: PropTypes.string.isRequired,
  useV3: PropTypes.bool.isRequired,
};

EmailInput.defaultProps = {
  error: '',
};

export default EmailInput;
